import { gsap } from 'gsap'
import { Swiper } from 'swiper'

$('body').on('click', '[data-fine-tab-nav]', function (e){
  e.preventDefault()
  $('.fines-block .is-active').removeClass('is-active')
  let contentID = $(this).data('fine-tab-nav')
  $(this).addClass('is-active')
  $('[data-fine-tab-content="'+contentID+'"]').addClass('is-active')

  gsap.fromTo('[data-fine-tab-content="'+contentID+'"]', { opacity: 0 }, { opacity: 1, duration: 0.75, delay: 0.15 })
})

if($('.fines-tabs-slider').length) {

  $(window).on('load', function (e){
    var finesSwiper = new Swiper(".fines-tabs-slider", {
      slidesPerView: "auto",
      spaceBetween: 2,
      freeMode: true,
    });
  })

}
